import { CheckCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableSatisfiedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DeliverableSatisfiedEventProps {
  event: DiscriminatedDeliverableSatisfiedEvent;
}

export const DeliverableSatisfiedEvent: React.FC<
  DeliverableSatisfiedEventProps
> = ({ event }) => {
  const { deliverable } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100">
          <CheckCircleIcon className="h-4 w-4 text-emerald-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>
        {deliverable?.name || 'Deliverable completed'}
      </ActivityTitle>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Satisfied"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
